import * as React from 'react';

// modules
import LoadingManager from '../modules/loading-manager';
import RootComposer from 'modules/root-composer';
import ErrorPage from '../modules/error-page';

// components
import Router from '../router';
import Header from 'components/header/header.component';
import Content from 'components/content';
import Footer from 'modules/footer';
import ErrorBoundary from 'components/error-boundary';
import StandaloneOnly from 'modules/standalone-only';

// types
import { ILoginSession } from 'types/session';
import IConfig from '@sitegen/common/constants/config';
import { IGenericFunction } from 'types/generics';
import { IPlatformEvent } from 'modules/event-manager';

export interface IRootStoreProps {
    config: IConfig;
    loginSession: ILoginSession | undefined;
    activeLanguageCode: string;
    eventPlatforms: Array<IPlatformEvent> | undefined;
}

interface IRootDispatchProps {
    logOut: IGenericFunction<void>;
    fetchLanguage: (languageCode: string) => void;
}

interface IRootProps extends IRootStoreProps, IRootDispatchProps {}

export class Root extends React.Component<IRootProps> {
    private getEventPlatforms = (): Array<string> => (
         this.props.eventPlatforms?.map(item => item.platform) ?? []
    );

    public render() {
        return (
            <RootComposer>
                <LoadingManager>
                    <StandaloneOnly mode={this.props.config.mode}>
                        <Header/>
                    </StandaloneOnly>
                    <Content>
                        <ErrorBoundary fallbackComponent={<ErrorPage/>}>
                            <Router/>
                        </ErrorBoundary>
                    </Content>
                    <StandaloneOnly mode={this.props.config.mode}>
                        <Footer
                            availablePlatforms={this.getEventPlatforms()}
                            activeLanguageCode={this.props.activeLanguageCode}
                            availableLanguageTags={this.props.config.availableLanguages}
                            fetchLanguage={this.props.fetchLanguage}
                        />
                    </StandaloneOnly>
                </LoadingManager>
            </RootComposer>
        );
    }
}

export default Root;
